import Flex from '@Components/Bases/Flex';
import { Avatar, Box, Typography } from '@mui/material';

export type UserProfileButtonProps = {
  name?: string;
  surname?: string;
  role?: string;
};

const UserProfileButton = ({ name, surname, role }: UserProfileButtonProps) => {
  return (
    <Box>
      <Flex aria-haspopup="true" height={48} alignItems={'center'}>
        <Flex flexDirection={'column'} mr={1}>
          <Typography textAlign={'end'}>
            ยินดีต้อนรับ {name} {surname}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            textAlign={'end'}
          >
            {role}
          </Typography>
        </Flex>
        <Avatar sx={{ width: 24, height: 24, mr: 1 }} />
      </Flex>
    </Box>
  );
};

export default UserProfileButton;
